(function () {
  var heading = document.querySelector('.shopify-policy__title h1');
  if (!heading) return;

  var PROBE_SIZE = 100;

  // Measure the TEXT, not the element box. The box is capped by max-width:100%, so reading its
  // own width (offsetWidth/scrollWidth/getBoundingClientRect) reports that cap rather than how
  // wide the white-space:nowrap text actually renders — which is what left the heading oversized.
  var measureText = function () {
    var range = document.createRange();
    range.selectNodeContents(heading);
    var width = range.getBoundingClientRect().width;
    if (range.detach) range.detach();
    return width;
  };

  var fitToWidth = function () {
    var container = heading.parentElement;
    if (!container) return;

    var containerStyles = window.getComputedStyle(container);
    var containerPaddingX = parseFloat(containerStyles.paddingLeft) + parseFloat(containerStyles.paddingRight);
    var available = container.clientWidth - containerPaddingX;
    if (!available || available <= 0) return;

    heading.style.fontSize = PROBE_SIZE + 'px';

    var probeWidth = measureText();
    if (probeWidth > 0) {
      var size = (available / probeWidth) * PROBE_SIZE;
      heading.style.fontSize = size + 'px';

      // Verify against the real rendered text and correct. The probe can be measured in a
      // fallback font if a custom font (Akira Expanded) is still loading, so re-check until the
      // text genuinely fits rather than trusting a single ratio.
      for (var i = 0; i < 5; i++) {
        var actual = measureText();
        if (actual <= 0 || actual <= available) break;
        size = size * (available / actual) * 0.999;
        heading.style.fontSize = size + 'px';
      }
    }

    heading.style.visibility = 'visible';
  };

  fitToWidth();
  window.addEventListener('resize', fitToWidth);

  // Defer timing can run before custom fonts finish loading, so re-measure once they're in.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(fitToWidth);
  }
})();
